import moment from 'moment';
import pearClient from 'apis/pearClient';
import { dateWithTimezone } from 'utils/dateTime';
import { getEventChangeDateTrackingValues } from 'utils/highcharts';

interface IEvent {
  trigger: string;
  min: number;
  max: number;
  rangeSelectorButton: {
    text: string;
  };
}

const ONE_DAY = 24 * 3600 * 1000;

/** Incorporates native HighCharts rangeSelector features */

export const intensityChartConfig = (
  id: string,
  timezone: string,
  maxDate: string,
) => ({
  title: { text: '' },
  lang: { noData: 'No data available' },
  time: {
    timezone,
  },
  series: [],
  credits: { enabled: false },
  chart: {
    type: 'scatter',
    renderTo: id,
    backgroundColor: 'transparent',
    spacingLeft: 0,
    styledMode: true,
  },
  plotOptions: {
    series: {
      pointRange: ONE_DAY,
      pointPlacement: 'on',
    },
  },
  xAxis: {
    title: {
      text: 'Date',
    },
    tickWidth: 0,
    type: 'datetime',
    dateTimeLabelFormats: { day: '%b %d' },
    tickInterval: ONE_DAY,
    minRange: ONE_DAY * 7,
    softMax: moment(maxDate).valueOf(),
    events: {
      setExtremes: (event: IEvent) => {
        const tab = 'Cravings';
        const { button, from, to } = getEventChangeDateTrackingValues(
          event,
          timezone,
        );
        if (button) {
          pearClient.v2.tracking.trackDateRangeChangeEvent(
            tab,
            button,
            from,
            to,
          );
        }
      },
    },
  },
  yAxis: {
    title: {
      text: 'Craving Intensity',
    },
    min: 0,
    max: 10,
    tickInterval: 5,
    showLastLabel: true,
    opposite: false,
    labels: { x: -8, y: 4 },
  },
  navigator: {
    enabled: false,
  },
  scrollbar: {
    enabled: false,
  },
  legend: { enabled: false },
  rangeSelector: {
    enabled: false,
  },
  tooltip: {
    formatter: function intensityTooltip(this: {
      x: number;
      y: number;
    }): string {
      const formattedDate = dateWithTimezone(timezone, this.x).format(
        'ddd, MMM DD, YYYY',
      );
      return `${formattedDate} <br/><b>Intensity: ${this.y}</b>`;
    },
  },
});
